export const sushi = {
  hero: {
    title: 'Read how De Wethouder found a reliable online partner in Bistroo',
    description: 'De Wethouder Food & Drink Club is a trendy establishment located in the former town hall of Denekamp. They offer a varied and ever-changing menu, with the unique walking dinner concept as the highlight.'
  },
  testimonials: {
    1: {
      text: 'With Bistroo’s ordering solution, we were able to process orders accurately and manage their fulfillment. This led to fewer mistakes and improved customer satisfaction.',
      name: 'John de Boer',
      job_title: 'Manager'
    },
    2: {
      text: 'Using Bistroo for selling sushi to go turned out to be highly successful and efficient, which contributed to better service and an improved customer experience. We would’ve never known this otherwise!',
      name: 'Tjeerdje Akkerman',
      job_title: 'Operational Lead'
    }
  },
  challenge: {
    paragraph: {
      title: 'Sustainable collaboration',
      text: 'In addition to their dine-in experience, they also offer sushi to go, a popular offering sold through Bistroo. De Wethouder has been working with Bistroo for over 2 years and briefly shares the challenges they faced before the collaboration and the solutions Bistroo provides.'
    },
    paragraph_2: {
      title: 'The challenge',
      bullets: {
        1: 'During peak hours, De Wethouder Food & Drink Club was overwhelmed with orders, causing staff to be overworked and customers to experience longer wait times.',
        2: 'Managing and fulfilling orders was a challenge, especially during busy times.',
        3: 'It was crucial to ensure orders were processed accurately to minimize errors and maintain customer satisfaction.'
      }
    }
  },
  solution: {
    title: 'The solution',
    checklist: {
      1: 'Thanks to Bistroo’s online ordering solution, De Wethouder Food & Drink Club could easily and efficiently manage their sushi to go offering. Customers could conveniently order and pick up online, streamlining the process.',
      2: 'With Bistroo’s ordering solution, De Wethouder Food & Drink Club could accurately process and manage orders. This led to fewer errors and improved customer satisfaction.',
      3: 'Bistroo provided flexibility and adaptability, allowing the restaurant to quickly respond to changing needs and new opportunities, such as offering sushi to go.'
    }
  },
  conclusion: {
    title: 'Conclusion',
    text: {
      1: 'Thanks to Bistroo’s online ordering solution, De Wethouder Food & Drink Club not only improved their operational efficiency but also increased customer satisfaction and capitalized on growth opportunities. Using Bistroo for sushi to go proved highly successful and efficient, contributing to better service and an enhanced customer experience. Bistroo stands out with its hospitality, actively thinking along in solutions and new opportunities for De Wethouder. This approach creates strong trust and strengthens the collaboration between both parties.',
      2: 'Moreover, Bistroo is available 24/7 to support De Wethouder Food & Drink Club, regardless of the time. This continuous support provides the restaurant with peace of mind and confidence in their online ordering process. De Wethouder Food & Drink Club highly recommends Bistroo to other hospitality businesses seeking a flexible and efficient online ordering solution.'
    }
  }
}
